/**
 * Typed OG meta exports backed by JSON data.
 *
 * The route/default/bot configuration lives in ogMeta.json so route metadata can
 * stay data-shaped. This file provides typed exports for TypeScript consumers.
 *
 * When you add or rename a route in index.ts, add the corresponding entry to
 * ogMeta.json, then run: npm run generate:og
 */

import ogMeta from "./ogMeta.json";

export type OgRouteMeta = {
  match: "exact" | "prefix";
  path: string;
  meta: {
    title: string;
    description: string;
  };
};

export type OgDefaultMeta = {
  title: string;
  description: string;
  image: string;
};

export type OgMetaConfig = {
  botPatterns: string[];
  defaultMeta: OgDefaultMeta;
  routeMeta: OgRouteMeta[];
};

const OG_META_CONFIG = ogMeta as OgMetaConfig;

export const OG_BOT_PATTERNS: string[] = OG_META_CONFIG.botPatterns;
export const OG_DEFAULT_META: OgDefaultMeta = OG_META_CONFIG.defaultMeta;
export const OG_ROUTE_META: OgRouteMeta[] = OG_META_CONFIG.routeMeta;

export function resolveOgMeta(path: string): OgDefaultMeta | OgRouteMeta["meta"] {
  const normalizedPath = path.length > 1 && path.endsWith("/") ? path.slice(0, -1) : path;
  const exactMatch = OG_ROUTE_META.find(
    (route) => route.match === "exact" && route.path === normalizedPath
  );
  if (exactMatch) return exactMatch.meta;

  const prefixMatch = OG_ROUTE_META.filter(
    (route) => route.match === "prefix" && normalizedPath.startsWith(route.path)
  ).sort((a, b) => b.path.length - a.path.length)[0];

  return prefixMatch?.meta ?? OG_DEFAULT_META;
}
